import React from 'react';
import { owlLoader } from 'assets/images';
import Lottie from 'react-lottie-player';
import loaderAnimation from './json-animation/credit-score.json';

interface CustomLoaderProps {
  show: boolean;
  title?: string;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({ show, title }) => {
  if (!show) {
    return null; // Return null if show is false to hide the loader
  }

  return (
    <div className='loader-container'>
      {title && <h4 className='loader-container__title'>{title}</h4>}
      <Lottie
        loop
        animationData={loaderAnimation} // Lottie JSON animation data
        play
        className='lottie-wrapper'
      />
    </div>
  );
};

export default CustomLoader;
